export default {"src":"https://uat.avacareclinicaltrials.com//_next/static/media/icon-marker.67e1b489.svg","height":28,"width":22,"blurWidth":0,"blurHeight":0};